import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import HighlightIcon from '@mui/icons-material/Highlight';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import NoteIcon from '@mui/icons-material/Note';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import * as React from 'react';
import { hasFeature } from '../../../../shared-components/contexts/InstitutionContext';
import LinkTile from './LinkTile';
import SettingsGroup from './SettingsGroup';

interface NotationManagementSettingsProps {
  linkIconTileClassName: string;
}

const NotationManagementSettings = ({
  linkIconTileClassName,
}: NotationManagementSettingsProps) => {
  return (
    <SettingsGroup title="Notations">
      <LinkTile to="/management/notation" text="Notation Management">
        <PlaylistAddCheckIcon
          className={linkIconTileClassName}
          style={{ margin: '0 0 0 15px' }}
        />
      </LinkTile>
      <LinkTile to="/management/categories" text="Notation Categories">
        <LocalOfferIcon className={linkIconTileClassName} />
      </LinkTile>
      {hasFeature('Notations 1.5') && (
        <LinkTile href="/beacon/settings/reason" text="Notation Reasons">
          <NoteIcon className={linkIconTileClassName} />
        </LinkTile>
      )}
      {hasFeature('DataInsights') && (
        <LinkTile href="/beacon/settings/trigger" text="Triggers">
          <HighlightIcon className={linkIconTileClassName} />
        </LinkTile>
      )}
      <LinkTile to="/management/notationwidget" text="Notation Widget">
        <ChatBubbleOutlineIcon className={linkIconTileClassName} />
      </LinkTile>
    </SettingsGroup>
  );
};

export default NotationManagementSettings;
